// extracted by mini-css-extract-plugin
export var actionText = "_jd-4";
export var container = "_jd-0";
export var leftSection = "_jd-1";
export var rightSection = "_jd-2";
export var settingsButton = "_jd-6";
export var settingsIcon = "_jd-7";
export var shortcut = "_jd-5";
export var shortcutGroup = "_jd-3";